
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/athletes/signin",
      function () {
        return require("private-next-pages/athletes/signin.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/athletes/signin"])
      });
    }
  